import api from "@/axios";

export default {
  find() {
    return api().get("admin/admin-statistics");
  },
};
